import SectionLayout from "../components/SectionLayout";
import SectionHeader from "../components/SectionHeader";
import SquareCard from "../components/SquareCard";
import GridLayout from "../components/GridLayout";

// icons
import {
  js,
  react,
  vscode,
  tailwind,
  csharp,
  node,
  photoshop,
  figma,
} from "../assets";

const tools1 = [
  {
    id: 1,
    name: "JavaScript",
    icon: js,
  },
  {
    id: 2,
    name: "React",
    icon: react,
  },
  {
    id: 3,
    name: "VS Code",
    icon: vscode,
  },
  {
    id: 4,
    name: "Tailwind",
    icon: tailwind,
  },
  {
    id: 5,
    name: "C#",
    icon: csharp,
  },
  {
    id: 6,
    name: "Node js",
    icon: node,
  },
  {
    id: 7,
    name: "Photoshop",
    icon: photoshop,
  },
  {
    id: 8,
    name: "Fgima",
    icon: figma,
  },
];

export default function Skills() {
  return (
    <SectionLayout id={"skills"} index={2}>
      <div className=" flex flex-row justify-center items-center sm:block min-h-screen w-full sm:mt-10">
        <SectionHeader>Skills & Tools</SectionHeader>
        {/* body */}
        <div>
          <GridLayout>
            {tools1.map((item, index) => {
              return (
                <SquareCard
                  key={item.id}
                  index={index}
                  title={item.name}
                  img={item.icon}
                />
              );
            })}
          </GridLayout>
        </div>
      </div>
    </SectionLayout>
  );
}
